import { render } from "./CommunitiesCreate.vue?vue&type=template&id=36498dd2"
import script from "./CommunitiesCreate.vue?vue&type=script&lang=js"
export * from "./CommunitiesCreate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__